import React, { useState } from 'react';
import classNames from 'classnames';
import PrenavMenu from '../ui/prenav-menu/PrenavMenu';
import styles from './prenav-link.scss';
import dispatchMonetateQEvent from '../../utils/monetate/monetateEventDispatcher';
import { notifyNavAnalytics } from '../navigation/notify-analytics';

const PrenavLink = props => {
  const clickHandler = e => {
    dispatchMonetateQEvent(
      `prenav-menu-click.${e.target.innerHTML.replace(/ /g, '-').toLowerCase()}`
    );
    notifyNavAnalytics('pn', e.target.innerHTML);
  };

  const [showmenu, setShowmenu] = useState(false);

  return (
    <li
      className={styles.headerLinksContainer}
      data-testid="prenav-redesign-container"
      onMouseEnter={() => setShowmenu(true)}
      onMouseLeave={() => setShowmenu(false)}
      onFocus={() => setShowmenu(true)}
    >
      <>
        <a
          key={props.children}
          className={classNames(styles.headerLinkItem, {
            [styles.underlinedHeaderLinkItem]: props.menuLinks.length === 0,
            [styles.headerLinkItem__prenav]: props.isNewPreNavActive,
            [styles.underlinedHeaderLinkItem__prenav]:
              props.menuLinks.length === 0,
          })}
          href={props.url || '#'}
          tabIndex={props.children ? 0 : -1}
          onClick={
            props.menuLinks.length > 0 ? e => e.preventDefault() : clickHandler
          }
        >
          {props.children}
        </a>
        {showmenu && props.menuLinks.length > 0 && (
          <PrenavMenu {...props} itemClassName={styles.prenavLinkMenuBox} />
        )}
      </>
    </li>
  );
};

export default PrenavLink;
